import {
  MARIGRAM_DATA_DELETE_MARIGRAM_REQUEST,
  MARIGRAM_DATA_CLEAR,
  MARIGRAM_DATA_COUNTRY_REQUEST,
  MARIGRAM_DATA_LOCATION_REQUEST,
  MARIGRAM_DATA_STATE_REQUEST,
  MARIGRAM_DATA_TOGGLE_COLUMN,
} from './marigramDataReducer';
import { MARIGRAM_DATA_SORT } from '../search/marigramSearchReducer';


export const deleteMarigram = ({ id, history }) => ({ type: MARIGRAM_DATA_DELETE_MARIGRAM_REQUEST, id, history });
export const getCountries = ({ history }) => ({ type: MARIGRAM_DATA_COUNTRY_REQUEST, history });
export const getLocations = ({ history }) => ({ type: MARIGRAM_DATA_LOCATION_REQUEST, history });
export const getStates = ({ history }) => ({ type: MARIGRAM_DATA_STATE_REQUEST, history });
export const clearMarigramData = () => ({ type: MARIGRAM_DATA_CLEAR });
export const sortData = sort => ({ type: MARIGRAM_DATA_SORT, sort });
export const toggleColumns = visibleColumns => ({ type: MARIGRAM_DATA_TOGGLE_COLUMN, visibleColumns });
